import { render, staticRenderFns } from "./ServerMyOffice.vue?vue&type=template&id=59e845e8&scoped=true&"
import script from "./ServerMyOffice.vue?vue&type=script&lang=js&"
export * from "./ServerMyOffice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e845e8",
  null
  
)

export default component.exports